import { Field, useFormikContext } from 'formik';
import { Grid, Typography, CardContent, Card } from '@mui/material';
import MuiCheckbox from 'src/components/input/MuiCheckbox';
import MuiValidTextField from 'src/components/input/MuiValidTextField';
import formatPhoneNumber from 'src/util/formatPhoneNumber';

export default function SubmittersInfoComponent({ sx = {} }) {
  const { setFieldValue } = useFormikContext();
  return (
    <Card>
      <CardContent sx={{ m: '0.125rem', ...sx }}>
        <Grid container>
          <Grid item xs={12}>
            <Typography>
              Under penalty of perjury (UCC 76-10-1801 and 76-8-414), I do hereby declare and affirm
              that this Personal Property Tax Statement reflects a full, true, and correct
              accounting of all personal property within Utah County, Utah subject to taxation which
              was owned, possessed, managed, or controlled by me at 12 {`o'clock`} noon on January
              1st of the filing year, that no property has been transferred out of Utah County or
              disposed of for the purpose of avoiding any assessment
            </Typography>
            <Field
              component={MuiCheckbox}
              name="signed"
              label={'I agree'}
              sx={{ float: 'right' }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={4}>
          <Grid item xs={12} md={4} sm={12}>
            <Field
              component={MuiValidTextField}
              name="submitterName"
              label={'Name'}
              variant="standard"
              sx={{ width: '100%' }}
              inputProps={{ maxLength: 30 }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={4} sm={12}>
            <Field
              component={MuiValidTextField}
              name="submitterEmail"
              label={'Email'}
              variant="standard"
              sx={{ width: '100%' }}
              type="email"
              inputProps={{ maxLength: 60 }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>{' '}
          <Grid item xs={12} md={4} sm={12}>
            <Field
              component={MuiValidTextField}
              name="submitterPhone"
              label={'Phone'}
              variant="standard"
              sx={{ width: '100%' }}
              type="tel"
              onChange={(e) =>
                setFieldValue('submitterPhone', formatPhoneNumber(e.currentTarget.value))
              }
              inputProps={{ maxLength: 12 }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              component={MuiValidTextField}
              name="remarks"
              label={'Remarks'}
              multiline
              rows={3}
              sx={{ width: '100%' }}
              inputProps={{ maxLength: 2000 }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
